import React from "react";

const XlsIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <defs>
      <filter id="ds" x="-20%" y="-20%" width="140%" height="140%">
        <feDropShadow dx="0" dy="2" stdDeviation="2" floodOpacity=".15" />
      </filter>
    </defs>
    <g filter="url(#ds)">
      <path
        d="M14 4H40L50 14V56C50 58.2 48.2 60 46 60H14C11.8 60 10 58.2 10 56V8C10 5.8 11.8 4 14 4Z"
        fill="white"
      />
      <path d="M40 4L50 14H40Z" fill="#ECECEC" />
    </g>
    <rect x="10" y="4" width="8" height="56" rx="2" fill="#107C41" />
    <rect x="22" y="16" width="20" height="20" rx="2" fill="#EAF7EE" />
    <path
      d="M28 16V36M34 16V36M22 22H42M22 28H42"
      stroke="#A8D9B7"
      strokeWidth="1"
    />
    <rect x="14" y="42" width="36" height="14" rx="7" fill="#107C41" />
    <text
      x="32"
      y="52"
      textAnchor="middle"
      fontFamily="Segoe UI, Arial, sans-serif"
      fontSize="10"
      fontWeight="700"
      fill="white"
    >
      XLS
    </text>
  </svg>
);

export default XlsIcon;